import { LoginForm } from 'model';
import { Props } from './types';

export const handleFormSubmitted = ({ logIn }: { logIn: Props['logIn'] }) => (
  values: LoginForm,
) => {
  logIn(values);
};
